import styled from 'styled-components';

export default styled.div`
  height: 65px;
  width: 65px;
`;
